import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parameter-inline-menu-col__header-text" }
const _hoisted_2 = {
  ref: "leftSelectorWrapper",
  class: "parameter-inline-menu-col__selector"
}
const _hoisted_3 = {
  key: 1,
  class: "parameter-inline-menu-col parameter-inline-menu-col--right"
}
const _hoisted_4 = { class: "parameter-inline-menu-col__header parameter-inline-menu-col__header--static" }
const _hoisted_5 = {
  ref: "rightSelectorWrapper",
  class: "parameter-inline-menu-col__selector parameter-inline-menu-col__selector--right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_inline_descriptor = _resolveComponent("inline-descriptor")!

  return (_openBlock(), _createBlock(_component_inline_descriptor, {
    ref: 'inlineDescriptor' + _ctx.id,
    id: _ctx.id,
    "model-value": _ctx.computedModel,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    schema: _ctx.computedSchema,
    "token-styles": _ctx.computedTokenStyles,
    "bold-selected": _ctx.boldSelected,
    separators: _ctx.separators,
    "update-token": _ctx.customUpdateToken,
    "is-table": _ctx.isTable,
    onUpdateMenu: _ctx.handleUpdateMenu,
    "enable-menu": _ctx.isRoot,
    "is-root-level": _ctx.isRoot,
    createMode: _ctx.createMode,
    editable: _ctx.editable,
    "plain-fields-open-menu": _ctx.menuForPlainFields,
    "is-vertical": _ctx.isVertical,
    "context-trigger": _ctx.contextTrigger,
    "move-to-body": _ctx.moveToBody,
    onReportWidths: _ctx.onReportWidths,
    onAddListItem: _ctx.addListItem,
    onRemoveListItem: _ctx.removeListItem,
    onClearField: _ctx.clearFieldValue,
    onAddValue: _ctx.addNewCreated,
    onTitleAction: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('title-action', $event))),
    "add-value-field-key": _ctx.addValueFieldKey,
    "show-field-label": _ctx.showFieldLabel,
    onBlur: _ctx.closeMenu,
    onKeydown: [
      _cache[5] || (_cache[5] = _withKeys(_withModifiers(
      () => {
        if (_ctx.$refs.aux_selector_def) {
          _ctx.$refs.aux_selector_def.trackArrowUp(1);
        } else if (_ctx.$refs.aux_selector_custom) {
          _ctx.$refs.aux_selector_custom.trackArrowUp(1);
        }
      }
    , ["exact","prevent"]), ["up"])),
      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
      () => {
        if (_ctx.$refs.aux_selector_def) {
          _ctx.$refs.aux_selector_def.trackArrowDown(1);
        } else if (_ctx.$refs.aux_selector_custom) {
          _ctx.$refs.aux_selector_custom.trackArrowDown(1);
        }
      }
    , ["exact","prevent"]), ["down"])),
      _cache[7] || (_cache[7] = _withKeys(_withModifiers(
      () => {
        let didSelect = false;
        if (_ctx.$refs.aux_selector_def) {
          didSelect = _ctx.$refs.aux_selector_def.selectCurrent();
        } else if (_ctx.$refs.aux_selector_custom) {
          didSelect = _ctx.$refs.aux_selector_custom.selectCurrent();
        }
        if (didSelect) _ctx.closeMenu();
      }
    , ["exact","prevent"]), ["enter"])),
      _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.closeMenu()), ["exact","prevent"]), ["esc"]))
    ]
  }, {
    "menu-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["parameter-inline-menu-row row no-wrap", { 'parameter-inline-menu-row--min-height-when-empty': _ctx.showBothBlocksEmpty }])
      }, [
        (
            _ctx.editable &&
            _ctx.isRoot &&
            _ctx.templateId &&
            _ctx.activeValueType === 4 &&
            _ctx.templateId !== 999
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["parameter-inline-menu-col parameter-inline-menu-col--left", { 'parameter-inline-menu-col--left-no-header': _ctx.templateId === 998 }])
            }, [
              (_ctx.templateId !== 998 && _ctx.hintedSetTypeFromSelector !== undefined && (!_ctx.sectionText || _ctx.hintedSetTypeFromSelector !== _ctx.V2ParameterValueSetExtensionType.Closed))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "parameter-inline-menu-col__header parameter-inline-menu-col__header--btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewCreated && _ctx.addNewCreated(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(this.sectionText ? _ctx.$t('add_value')+':' : _ctx.$t('reset_value')) + " " + _toDisplayString(this.sectionText), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_aux_selector, {
                  ref: "aux_selector_def",
                  style: {"min-width":"300px"},
                  "filter-model-value": _ctx.aux_filter_string,
                  "input-index": 0,
                  "show-search-header": false,
                  "limit-height-to-container": true,
                  "container-height-px": _ctx.leftSelectorHeightPx,
                  "component-model": _ctx.componentModel,
                  "allow-free-input": false,
                  "allow-multiple": true,
                  "model-type": _ctx.valueSetFromInstance ? 32 : 21,
                  "set-id": _ctx.templateId,
                  "instance-id": _ctx.instanceId || 0,
                  "is-parameter-instance": !_ctx.isRecordFieldInstance(_ctx.instanceId || 0),
                  modelValue: _ctx.defhints,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.defhints) = $event)),
                  onHintedSetType: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hintedSetTypeFromSelector = $event)),
                  onSelectorClosed: _ctx.closeMenu
                }, null, 8, ["filter-model-value", "container-height-px", "component-model", "model-type", "set-id", "instance-id", "is-parameter-instance", "modelValue", "onSelectorClosed"])
              ], 512)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.editable && _ctx.isRoot && _ctx.templateId !== 998 && (_ctx.useCustomHints ? _ctx.templateId !== 999 : _ctx.showCustom))
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.useCustomHints ? _ctx.$t('hints_label') : _ctx.$t('positions_label')) + ": ", 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_aux_selector, {
                  ref: "aux_selector_custom",
                  class: "parameter-inline-menu-col__selector-right",
                  style: {"min-width":"30vw","max-width":"70vw"},
                  "container-height-px": _ctx.rightSelectorHeightPx,
                  "show-search-header": false,
                  "limit-height-to-container": true,
                  "filter-model-value": _ctx.aux_filter_string,
                  "allow-free-input": false,
                  "allow-multiple": true,
                  "component-model": _ctx.componentModel,
                  "model-type": _ctx.useCustomHints ? 30 : 20,
                  "input-index": 0,
                  "set-id": _ctx.templateId,
                  modelValue: _ctx.rightSelectorModel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rightSelectorModel) = $event)),
                  onSelectedHint: _ctx.onCustomHintNotes,
                  onSelectorClosed: _ctx.closeMenu,
                  onDataAvailable: _ctx.onRightSelectorDataAvailable
                }, null, 8, ["container-height-px", "filter-model-value", "component-model", "model-type", "set-id", "modelValue", "onSelectedHint", "onSelectorClosed", "onDataAvailable"])
              ], 512)
            ], 512)), [
              [_vShow, _ctx.rightSelectorHasData === true]
            ])
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["id", "model-value", "onUpdate:modelValue", "schema", "token-styles", "bold-selected", "separators", "update-token", "is-table", "onUpdateMenu", "enable-menu", "is-root-level", "createMode", "editable", "plain-fields-open-menu", "is-vertical", "context-trigger", "move-to-body", "onReportWidths", "onAddListItem", "onRemoveListItem", "onClearField", "onAddValue", "add-value-field-key", "show-field-label", "onBlur"]))
}